const URL = 'https://amazon-tx9v.onrender.com';
// const URL = 'http://localhost:5000';

export default URL ;